/*
----------------------------------------------------------------------------
CODE FOR UI WIDGETS AND STYLE ADJUSTMENTS FOR MEDIUM AND SMALL DISPLAY SIZES
----------------------------------------------------------------------------
*/
; (function (global, $) {
    'use strict';

    function initializeMobileNavigation() {
        // func of plus btns class .submenu-btn
        $('.main-header-mobile .submenu-btn').click(function () {
            $(this).toggleClass('collapsed');
            $(this).first().parent().children('.collapse').collapse('toggle');
        });

        // close main nav menu when clicked outsite
        $(document).click(function (e) {
            // second check if clicked outsite of menu
            if (!$(e.target).hasClass('#navigation') && $(e.target).parents('.collapse').length === 0) {
                $('#navigation').collapse('hide');
                $('.main-mobile-btn').addClass('collapsed');
                // and all others
                $('.main-header-mobile .sub-menu').collapse('hide');
                $('.main-header-mobile .submenu-btn').addClass('collapsed');
            }
        });

        $('#HeaderMoreMenu').click(function () {
            $(this).toggleClass('open');
            $('#HeaderNavMenu').toggleClass('open');
        })

        $('#NavigationMoreMenu').click(function () {
            $(this).toggleClass('open');
            $('#header-menu').toggleClass('open');
        })
    }

    $(function () {
        initializeMobileNavigation();
    });


} (window, jQuery));